import React, { useCallback } from 'react';

import { Link } from 'react-router-dom';
import { formatPhoneNumberIntl, parsePhoneNumber } from 'react-phone-number-input';
import { Button } from '@material-ui/core';

import API from 'utils/api';
import { useSources } from 'hooks';
import { ButtonContainer, Table } from 'components';

import styles from './Users.module.scss';

const UserList = () => {
  const sources = useSources();

  const fetchData = useCallback(
    ({ search, ...rest }) =>
      API.getUsers(
        {
          ...rest,
          query: search
            ? JSON.stringify({ fullname: { $regex: search, $options: 'i' } })
            : undefined,
          select: 'fullname email phone active',
        },
        sources
      ),
    [sources]
  );

  return (
    <div className={styles.panel}>
      <ButtonContainer position="top">
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/dashboard/users/new"
        >
          create new user
        </Button>
      </ButtonContainer>

      <Table
        pageSize={10}
        columns={[
          {
            title: 'Full Name',
            field: 'fullname',
            weight: 2,
            defaultSort: 'desc',
          },
          { title: 'Email', field: 'email', weight: 2 },
          {
            title: 'Phone Number',
            field: 'phone',
            render: ({ phone }) => {
              const phoneNumber = parsePhoneNumber(phone);

              return (
                <span>
                  {phoneNumber ? formatPhoneNumberIntl(phoneNumber.number) : phone}
                </span>
              );
            },
          },
        ]}
        data={fetchData}
      />
    </div>
  );
};

export default UserList;
